export const API_PREFIX = "/1/apitun";
export const METHODS = {
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE",
};
export const DEFAULT_ERROR = {
	error: {
		message: "No error response",
		type: "DefaultError",
	},
};
export const NO_AJAX_LIB_ERROR = {
	error: {
		message: "Missing required files. Please refresh and try again.",
		type: "NoAjaxLibError",
	},
};

export default {
	API_PREFIX,
	METHODS,
	DEFAULT_ERROR,
	NO_AJAX_LIB_ERROR,
};



// WEBPACK FOOTER //
// ./src/shared/util/OkcApi/constants.js